import { ThemeUIStyleObject, ThemeUIContextValue } from "theme-ui";

export function mergeHeadingStyles(
  themeContext: ThemeUIContextValue,
  asHeading = "h2",
  variant = "heading"
): ThemeUIStyleObject {
  const headingTag = asHeading.toLowerCase();
  const variantStyle = variant.toLowerCase();

  const headingProps = themeContext.theme.styles?.[headingTag] ?? {};
  const headerVariantProps =
    themeContext.theme.text?.[variantStyle] ??
    themeContext.theme.styles?.[variantStyle] ??
    {};

  return { ...headingProps, ...headerVariantProps };
}
